"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _immutable = require("immutable");

function _default(object, propertyName) {
  if (!object) {
    return (0, _immutable.OrderedSet)();
  }

  var value = object.getIn(['properties', propertyName, 'value']);

  if (!value) {
    return (0, _immutable.OrderedSet)();
  }

  return (0, _immutable.OrderedSet)(String(value).split(';'));
}

module.exports = exports.default;